import { render, staticRenderFns } from "./ReportInvoices.vue?vue&type=template&id=4fdcff2e&scoped=true"
import script from "./ReportInvoices.vue?vue&type=script&lang=js"
export * from "./ReportInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdcff2e",
  null
  
)

export default component.exports